import React, {Fragment} from "react";
import {CLIENT_URL} from "config";
import BasicModal from "../../../../common/BasicModal";
import ZendeskSetupModalForm from "./ZendeskSetupForm";
import {basicModalStyle} from "../../Utilities/basicModalStyles";

export default function ZendeskSetupModal({open, handleClose, handleOpen}) {
    return(
        <Fragment>
            <BasicModal
                open={open}
                handleClose={handleClose}
                handleOpen={handleOpen}
                title={'Connect with Zendesk'}
                style={basicModalStyle}
            >
                <ZendeskSetupModalForm
                    description={'Please copy and paste your Zendesk subdomain here:'}
                    placeholder={'yoursubdomain'}
                    channelDomain={'.zendesk.com'}
                    extraInfoLabel={'View setup instructions'}
                    buttonLabel={'Submit'}
                    openInNewTab={true}
                    handleClose={handleClose}
                    callbackUrl={`${CLIENT_URL}/company/connectchannels`}
                />
            </BasicModal>
        </Fragment>
    )
}